module.exports = __webpack_public_path__ + "media/images/girl@2x-eadf5285.png";